<template>
<div class="chapter">
<div class="inner_page">
<p class="title"><a id="page_1">Upon Some Midnights Clear</a></p><a id="page_1">
<p class="author">K.C. Constantine</p>
<div class="img_containert"><img alt="image" src="images/logo3.jpg"/></div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Title.vue?2fa8b5e7